var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.60713 4L7.6833 0.333203C7.73486 0.272266 7.6915 0.179688 7.61181 0.179688H6.67666C6.62158 0.179688 6.56884 0.204297 6.53252 0.246484L3.99541 3.27109L1.4583 0.246484C1.42314 0.204297 1.37041 0.179688 1.31416 0.179688H0.379C0.299313 0.179688 0.255953 0.272266 0.307516 0.333203L3.38369 4L0.307516 7.6668C0.295965 7.68038 0.288555 7.69699 0.286165 7.71466C0.283775 7.73233 0.286505 7.75031 0.294031 7.76648C0.301558 7.78264 0.313565 7.79631 0.328626 7.80585C0.343687 7.81539 0.361171 7.82041 0.379 7.82031H1.31416C1.36923 7.82031 1.42197 7.7957 1.4583 7.75352L3.99541 4.72891L6.53252 7.75352C6.56767 7.7957 6.62041 7.82031 6.67666 7.82031H7.61181C7.6915 7.82031 7.73486 7.72774 7.6833 7.6668L4.60713 4Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.fe930df89e9fa483dbeabd0f4df8e88e.svg";
export { ForwardRef as ReactComponent };